// Global guard: session-recorder scripts patch window.fetch and can reject with
// "Failed to execute 'clone' on 'Response': Response body is already used".
// When that happens, transparently retry the request via XMLHttpRequest.

function xhrFetch(input, init = {}) {
  return new Promise((resolve, reject) => {
    const url = typeof input === "string" ? input : input.url;
    const method = (init.method || (typeof input === "object" && input.method) || "GET").toUpperCase();
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    const headers = init.headers || {};
    if (typeof Headers !== "undefined" && headers instanceof Headers) {
      headers.forEach((v, k) => { try { xhr.setRequestHeader(k, v); } catch {} });
    } else {
      Object.entries(headers).forEach(([k, v]) => { try { xhr.setRequestHeader(k, v); } catch {} });
    }
    if (init.credentials === "include") xhr.withCredentials = true;
    xhr.onload = () => {
      const status = xhr.status || 200;
      const respHeaders = new Headers();
      (xhr.getAllResponseHeaders() || "").trim().split(/[\r\n]+/).forEach((line) => {
        const idx = line.indexOf(": ");
        if (idx > 0) { try { respHeaders.append(line.slice(0, idx), line.slice(idx + 2)); } catch {} }
      });
      const body = [101, 204, 205, 304].includes(status) ? null : xhr.responseText;
      resolve(new Response(body, { status, statusText: xhr.statusText, headers: respHeaders }));
    };
    xhr.onerror = () => reject(new TypeError("Failed to fetch"));
    xhr.ontimeout = () => reject(new TypeError("Request timed out"));
    xhr.send(init.body != null ? init.body : null);
  });
}

const underlyingFetch = window.fetch.bind(window);

window.fetch = async function guardedFetch(input, init) {
  try {
    const resp = await underlyingFetch(input, init);
    if (resp && resp.bodyUsed) return xhrFetch(input, init || {});
    return resp;
  } catch (err) {
    if (err && typeof err.message === "string" && err.message.toLowerCase().includes("clone")) {
      return xhrFetch(input, init || {});
    }
    throw err;
  }
};
